export const hiddenPositions = [];
export const hiddenPositionsAmount =  { 'Austin': 0, 'Cedar Rapids': 0 };
